// Tab Switcher

class TabSwitcher extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.addEventListener('change', () => this.handleTabChange(radio, { scrollTabs: true }));
      });
  
      document.addEventListener('shopify:section:select', () => {
        const radio = this.querySelector('input[type="radio"]:checked');
        this.handleTabChange(radio, { scrollTabs: false });
      });
  
      const checkedRadio = this.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        this.handleTabChange(checkedRadio, { scrollTabs: false });  
      } else {
        const firstRadio = this.querySelector('input[type="radio"]');
        if (firstRadio) {
          firstRadio.checked = true;  
          this.handleTabChange(firstRadio, { scrollTabs: false });  
        }
      }
  
      window.addEventListener('resize', () => {
        const radio = this.querySelector('input[type="radio"]:checked');
        if (radio) {
          this.updateGliderPosition(radio, { scrollTabs: false });
        }
      });
    }
  
  handleTabChange(radio, { scrollTabs = false } = {}) {
      if (!radio) return;
      const parts = radio.id.split('-');
      const sectionId = parts[1];
  
      if (parts.length < 3) {
          return; 
      }
  
      const collectionNumber = parseInt(parts[parts.length - 1], 10) - 1;
  
      this.querySelectorAll('.tab-content > div').forEach((content, index) => {
          if (index === collectionNumber) {
              content.style.display = 'block';
              content.setAttribute('data-aos', 'fade-up');
          } else {
              content.style.display = 'none';
              content.removeAttribute('data-aos');
              content.classList.remove('aos-animate');
          }
      });
  
      this.updateGliderPosition(radio, { scrollTabs });
  
      if (typeof AOS !== 'undefined') {
      AOS.init();
  }
  
  }
  
    updateGliderPosition(radio, { scrollTabs = false } = {}) {
      const glider = this.querySelector('.glider');
      const selectedLabel = radio.nextElementSibling;
      if (!glider || !selectedLabel) return;

      const tabWidth = selectedLabel.offsetWidth;
      const tabLeft = selectedLabel.offsetLeft;

      glider.style.width = `${tabWidth}px`;
      glider.style.transform = `translateX(${tabLeft}px)`;

      // Never scroll the page into the tabs on first paint — that hides the header/hero.
      if (scrollTabs && this.querySelector('.tabs') && selectedLabel.scrollIntoView) {
        selectedLabel.scrollIntoView({
          behavior: 'smooth',
          inline: 'center',
          block: 'nearest'
        });
      }
    }
  }
  
  customElements.define('tab-switcher', TabSwitcher);